// LEDGER — editorial serif list with live search. A 2px ink rule under the
// masthead, mono numbering, serif questions, and a search box that filters
// rows live via the search runtime ([data-text] rows + .fq-empty message).
//  - headings in ctx.v.head (serif unless the design picks another), numbers in ctx.v.mono
function itemHtml(ctx, it) {
    return `<div class="fq-acc" data-text="${it.searchText}">
  <button class="fq-qbtn" type="button" aria-expanded="false" aria-controls="p-${it.idx}">
    <span class="fq-num">${it.num}</span>
    <span class="fq-q">${it.q}</span>
    ${ctx.showIcon ? ctx.icon : ''}
  </button>
  <div class="fq-panel" id="p-${it.idx}" role="region"><div><div class="fq-a">${it.aHtml}</div></div></div>
</div>`;
}
const ledger = {
    id: 'ledger',
    name: 'Ledger',
    tag: 'Searchable list',
    styleTag: 'Editorial serif',
    description: 'An editorial, serif-set list with live search filtering and numbered entries. Built for longer FAQs where people come to find one specific answer \u2014 fast.',
    layout: 'list',
    defaultAccent: '#0b2a46',
    darkDefault: false,
    catSupport: 'none',
    features: ['accordion', 'search'],
    render(ctx) {
        const html = `<div class="fq-wrap">
  <div class="fq-head">
    <div>
      <h2 class="fq-title">${ctx.title}</h2>
      ${ctx.subtitle ? `<p class="fq-sub">${ctx.subtitle}</p>` : ''}
    </div>
    <div class="fq-search">
      ${ctx.svg.search}
      <input class="fq-searchbox" type="search" placeholder="${ctx.t('search')}" aria-label="${ctx.t('search')}">
    </div>
  </div>
  <div class="fq-list">
${ctx.items.map((it) => itemHtml(ctx, it)).join('\n')}
    <p class="fq-empty" role="status" hidden>${ctx.t('noResults')}</p>
  </div>
</div>`;
        const css = `
.FQM .fq-wrap{max-width:760px;margin:0 auto}
.FQM .fq-head{display:flex;flex-wrap:wrap;align-items:flex-end;justify-content:space-between;gap:18px;padding-bottom:22px;border-bottom:2px solid ${ctx.v.ink}}
.FQM .fq-title{margin:0 0 6px;font-family:${ctx.v.head};font-size:38px;font-weight:550;line-height:1.08;letter-spacing:-0.01em;color:${ctx.v.ink}}
.FQM .fq-sub{margin:0;font-size:15px;line-height:1.5;color:${ctx.v.sub};font-style:italic;font-family:${ctx.v.serif}}
.FQM .fq-search{display:flex;align-items:center;gap:8px;flex:0 1 260px;min-width:min(100%,220px);padding-bottom:4px;border-bottom:1px solid ${ctx.v.border}}
.FQM .fq-search .fq-svg{font-size:12px;color:${ctx.v.sub}}
.FQM .fq-searchbox{appearance:none;border:0;background:transparent;flex:1;min-width:0;width:auto;padding:4px 0;font-family:inherit;font-size:14px;color:${ctx.v.ink}}
.FQM .fq-searchbox::placeholder{color:${ctx.v.sub}}
.FQM .fq-acc{border-bottom:1px solid ${ctx.v.border}}
.FQM .fq-qbtn{display:flex;width:100%;align-items:baseline;gap:22px;padding:24px 4px}
.FQM .fq-num{flex:0 0 auto;font-family:${ctx.v.mono};font-size:13px;letter-spacing:0.06em;color:${ctx.v.accent}}
.FQM .fq-q{flex:1;font-family:${ctx.v.head};font-size:21px;font-weight:550;line-height:1.35;color:${ctx.v.ink}}
.FQM .fq-qbtn .fq-ic{font-size:13px;color:${ctx.v.sub};align-self:center}
.FQM .fq-a{padding:0 44px 26px 51px;font-size:15.5px;line-height:1.7;color:${ctx.v.sub}}
.FQM .fq-empty{padding:28px 4px;margin:0;font-size:15px;color:${ctx.v.sub};font-style:italic;font-family:${ctx.v.serif}}
`;
        return { html, css };
    },
};
export default ledger;
